import React from 'react';
import autoBind from 'react-autobind';
import _ from 'lodash';

import IDVerificationForm from './IDVerificationForm.jsx';
import IDVerificationSummary from './IDVerificationSummary.jsx';

export default class Individual extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    getVerficiationForms() {
        let verficiationForms = [];

        _.each(this.props.data.verificationDocuments, (doc, idx) => {
            const uniqueKey = this.props.data.investorId + '_doc' + idx;
            if (doc.isEditing) {
                verficiationForms.push(
                    <div className="col-xs-12 digital-consent-individual__item" key={'form_' + uniqueKey}>
                        <IDVerificationForm docId={doc.id} options={this.props.options} model={doc}
                        investorId={this.props.data.investorId} docIdx={idx}
                        updateVerificationDocument={this.props.updateVerificationDocument} />
                    </div>
                );
            } else {
                verficiationForms.push(
                    <div className="col-xs-12 digital-consent-individual__item" key={'summary_' + uniqueKey}>
                        <IDVerificationSummary docId={doc.id} investorId={this.props.data.investorId} model={doc} 
                        updateVerificationDocument={this.props.updateVerificationDocument} />
                    </div>
                );
            }
        });
        return verficiationForms;
    }

    render() {
        let verificationForms = this.getVerficiationForms();
        return (
            <div className="digital-consent-individual" key={'digital-consent-individual__' + this.props.data.investorId}>
                <div className="row">
                    <div className="col-xs-12 digital-consent-individual__name">For <span>{this.props.data.fullName}</span></div>
                </div>
                <div className="row">
                    <p className="col-xs-12">Please note: this screen does not form part of the application form. The information collected here is to 
                    assist with identification procedures (for the purposes of Anti-Money Laundering and Counter-Terrorism Financing laws).
                    </p>
                </div>
                <div className="row">
                    {verificationForms}
                </div>
            </div>
        );
    }
}

Individual.propTypes = {
    data: React.PropTypes.object.isRequired,
    options: React.PropTypes.array.isRequired,
    hasAllRequirements: React.PropTypes.bool.isRequired,
    updateVerificationDocument: React.PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/IDVerification/Individual.jsx